import Vue from 'vue';
import MortgageInOwnPage from '@/components/Mortgage/MortgageInOwnPage.vue';
import { RootElementAttrsHolder } from '@/plugins/RootElementAttrsPlugin';
import { ModalData } from '../FeedbackWidget/types';
import { MortgageProps } from '@/components/Mortgage/types';
import { JSONParser } from '@/utils/JSONParser';

export function createMortgageWidget(el: Element) {
    if( el ) {

        const parser = new JSONParser('createMortgageWidget');
        const rootAttrs = new RootElementAttrsHolder(el);

        const fetchUrl = el.getAttribute('data-fetch-url')!;
        const modalData = el.getAttribute('data-modal-data');

        const props: MortgageProps = {
            fetchUrl,
            modalData: parser.parse<ModalData>(modalData),
        };

        return new Vue({
            el,
            name: 'MortgageWidget',
            rootAttrs,
            render: (h) => h(MortgageInOwnPage, {props}),
        });
    }
}
